import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
/**
 * Returns a unique id that is stable across rerenders.
 * Inspired by https://github.com/Spidy88/react-use-uuid/blob/master/index.js
 * @returns
 */
export function useId(options) {
    let [id] = useState(() => {
        return uuidv4(options);
    });
    return id;
}
//# sourceMappingURL=useId.js.map